(function() {
    'use strict';

    // @see The <a href='http://jira.odigeo.com/wiki/display/MOBILEWEB/Advertisement'>Confluence page</a> //
    Odigeo.UIElements.enhanceLinkOpenNewTabBackground = function(el) {
        var $el = (el instanceof $) ? el : $(el);
        var openInBackgroundTab;
        var url = $el.data('url');

        if ($el.attr('data-skip-enhance') === 'true') {
            return;
        }

        $el.attr({'data-skip-enhance': true});

        openInBackgroundTab = function() {
            var a;
            var evt;
            if (!Odigeo.Device.navigator.isChrome) {
                window.open(url, 'ads', 'menubar=1,resizable=1,width=600,height=800,scrollbars=yes');
            } else {
                a = document.createElement('a');
                a.target = '_blank';
                a.href = url;
                evt = document.createEvent('MouseEvents');
                evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, true, false, false, true, 0, null);
                a.dispatchEvent(evt);
            }
        };

        $el.on(Odigeo.Events.tap, openInBackgroundTab);

        return $el;
    };
}());
